import {Component, input, OnInit} from '@angular/core';
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Component({
  selector: 'app-block-style-table',
  standalone: true,
  imports: [],
  templateUrl: './block-style-table.component.html',
  styleUrl: './block-style-table.component.css'
})
export class BlockStyleTableComponent implements OnInit {
  data = input<any>();

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    console.log('table:', this.data());
  }

  sanitize(cell: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(cell);
  }
}
